<template>
  <div class="panel-placeholder-group">
    <ck-icon
      v-if="data.icon"
      :name="`ico-${data.icon.name}-${data.icon.size}`"
      :fill="data.icon.fill"
      :size="data.icon.size"
    />
    <span v-if="data.title" class="title">{{ data.title }}</span>
    <span v-if="data.subtitle" class="subtitle">{{ data.subtitle }}</span>
    <ck-button
      v-if="data.action"
      class="action"
      :action="data.action.text"
      :full-width="false"
      @click.native.stop="$router.push({ name: data.action.route })"
    />
  </div>
</template>

<script>
import CkButton from '@/components/kit/CkButton'

export default {
  components: {
    CkButton
  },
  props: {
    data: Object
    /*
    { 
      icon: {
      name: 'energysetup',
      fill: 'grey-dark',
      size: '32px'
    },
    title: '',
    subtitle: '',
    action: {
      text: '',
      route: 'energy-settings-tariff'
    }
    */
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.panel-placeholder-group {
  .lh-display(flex);
  .lh-align-items(center);
  .lh-flex-direction(column);
  line-height: 21px;
  padding: @space-m 0 @space-ml;
  text-align: center;

  .title {
    .fontsize-m;
    .font-semibold;
    margin: 4px 0;
  }

  .subtitle {
    .fontsize-xxs;
  }

  .action {
    margin-top: @space-s;
  }
}
</style>
